"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getMomentObjectFromDate = _interopRequireDefault(require("./getMomentObjectFromDate"));

var _dateUnits = require("../constants/dateUnits");

var _allowedDateUnits = [_dateUnits.MILLISECONDS, _dateUnits.DAYS, _dateUnits.WEEKS, _dateUnits.MONTHS, _dateUnits.YEARS];

var _isAllowedDateUnit = function _isAllowedDateUnit(unit) {
  return _allowedDateUnits.indexOf(unit) >= 0;
};

var _default = function _default(d1, d2) {
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dateUnits.DAYS;

  if (unit && !_isAllowedDateUnit(unit)) {
    return console.error("The date unit provided \"" + unit + "\" is not allowed. Allowed date units: " + _allowedDateUnits.toString());
  }

  var date1 = (0, _getMomentObjectFromDate.default)(d1);
  var date2 = (0, _getMomentObjectFromDate.default)(d2);
  var dateDifference = date1.diff(date2, unit); // Moment returns NaN if either date string is invalid

  if (isNaN(dateDifference)) {
    return console.error("One of the date string's provided are invalid. Date 1: " + d1 + " | Date 2: " + d2);
  }

  return dateDifference;
};

exports.default = _default;
module.exports = exports.default;